export default "__VITE_ASSET__efd353c5__"